export const STANDARD_LEVEL = 'a';

export type GradeBand = 'g2_3' | 'g4_5' | 'g6_7' | 'g8_9' | 'g10_11' | 'g12_plus';

export const AI_GRADE_BANDS: GradeBand[] = [
  'g2_3',
  'g4_5',
  'g6_7',
  'g8_9',
  'g10_11',
  'g12_plus',
];

export const GRADE_BAND_LABELS: Record<GradeBand, string> = {
  g10_11: 'G10-11',
  g12_plus: 'G12+',
  g2_3: 'G2-3',
  g4_5: 'G4-5',
  g6_7: 'G6-7',
  g8_9: 'G8-9',
};

export interface ReadingLevelOption {
  disabled?: boolean;
  isAI: boolean;
  label: string;
  value: string;
}

export type ReadingGradeLevels = null | 'a' | 'b' | 'g2_3' | 'g4_5' | 'g6_7' | 'g8_9' | 'g10_11' | 'g12_plus';
